import { Component, OnInit } from '@angular/core';
import {BackendService, ServerInfo} from '../backend.service';
import {interval, Subscription} from 'rxjs';
import {switchMap} from 'rxjs/operators';

@Component({
  selector: 'app-admin-index',
  templateUrl: './admin-index.component.html',
  styleUrls: ['./admin-index.component.css']
})
export class AdminIndexComponent implements OnInit {
  private serverInfo: ServerInfo;
  private subscription: Subscription;

  constructor(private backend: BackendService) { }

  ngOnInit() {
    this.subscription = interval(1000) // co 1000ms
      .pipe(
        switchMap(() => this.backend.serverInfo())
      )
      .subscribe(serverInfo => {
        this.serverInfo = serverInfo;
      });

  }

}
